import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

/** CustomerSupportSerivce */
@Injectable({
    providedIn: 'root',
  })

export class CustomerSupportSerivce {
    /** add banner to review page */
    public addBannerToHWReviewPage: boolean = false;
    /**
     *
     * @param {TranslateService} ts
     */
    public constructor (private ts: TranslateService) {}
    /** set value for add banner to HW review page */
    public setAddBannerToHWReviewPage (value: boolean) {
        this.addBannerToHWReviewPage = value;
    }
    /** get value add banner to HW review page */
    public getAddBannerToHWReviewPage () {
        return this.addBannerToHWReviewPage ;
    }

    /**
     * get hotline number from cms based on sales channel
     * in case number is not mapped from cms take default
     * @param {string} cmsPath
     * @param {string} salesChannel
     */
    public getHotLineNumber (cmsPath: string, salesChannel: string) {
        return this.ts.get(cmsPath).pipe(map((data) => {
            const hotLineNumber =  data[salesChannel] ? data[salesChannel]['std-id'] : data['default']['std-id'];

            return hotLineNumber;
        }));
    }
}
